import {ModuleWithProviders, NgModule} from '@angular/core';

import { ApiService, BackendService } from './http';

import { BaseModel, Relationship, ModelFactory } from './models';
import {CONFIG} from './constants';

@NgModule({
  providers: [
      ApiService,
      BackendService
  ],
  declarations: [

  ],
  exports: [
  ]
})
export class ModelModule {
    public static forRoot(config): ModuleWithProviders {
        return {
            ngModule: ModelModule,
            providers: [{ provide: CONFIG, useValue: config}]
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/model.module.ts